import { PermissionT } from "../types";

export const enterpriseCustomFieldsAccess = (permissions: PermissionT[]): boolean => {
  const p = permissions.find((permission) => permission.name === "enterprise_custom_fields_access");
  return !!p;
};

export default enterpriseCustomFieldsAccess;
